export default __webpack_public_path__ + "static/media/icons8_2nd_place_medal 1.db13ff48.svg";